.scheduleCallbackFormContainer {
    height: auto;
    width: auto;
    min-width: 20rem;
    max-width: 25rem;
    z-index: var(--mantine-priority-highest);
    color: white;
    border-bottom-left-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
    padding-bottom: 1rem;
    margin: unset;
}
